module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/sample_daily-f1e5e17ff59f77dded6ddcbaf39d45ea.jpg";